/* Only dismissal is enhanced; native details and localization submission stand alone. */
(() => {
  if (window.martenbrownLocalizationInitialized) return;
  window.martenbrownLocalizationInitialized = true;
  const openChoosers = () => document.querySelectorAll('.mb-language-switcher[open]');
  document.addEventListener('click', (event) => {
    openChoosers().forEach((chooser) => {
      if (!chooser.contains(event.target)) chooser.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const choosers = [...openChoosers()];
    const focused = choosers.find((chooser) => chooser.contains(document.activeElement));
    choosers.forEach((chooser) => { chooser.open = false; });
    if (focused) focused.querySelector('summary').focus();
  });
})();
